import { createAction } from 'redux-actions';

export const appMounted = createAction('APP_MOUNTED', (pageName: string, biComponent?: string) => ({
  pageName,
  biComponent,
}));
